__turbopack_context__.v({
  "cartButton": "CartButton-module-scss-module__eTRwca__cartButton",
  "cartOpen": "CartButton-module-scss-module__eTRwca__cartOpen",
  "wobbleBottom": "CartButton-module-scss-module__eTRwca__wobbleBottom",
});
